module.exports = __webpack_public_path__ + "img/promote.df05db2.svg";